import type { JSX } from 'react';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { getSelectedLanguage } from '@frontend/translate';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { ProcessActivityReadContext } from '../../../carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { addOsasQuestionnaireResults } from './utils/addOsasQuestionnaireResults';
import { addOsasQuestionnaireProgressBars } from './utils/addQuestionnaireProgressBars';

export function OsasQuestionnairesRead(): JSX.Element {
    const { patient } = usePatientEpisodeCategoryContext();

    const { readSections } = useDefinedContext(ProcessActivityReadContext);

    const language = getSelectedLanguage();

    return (
        <>
            <FormParagraphFormGroup label={language.osas.questionnairesSentTo}>
                {patient.emailAddress}
            </FormParagraphFormGroup>

            <ReadForm components={getComponents()} />
        </>
    );

    function getComponents(): ComponentsMap {
        const map = new Map();
        addOsasQuestionnaireProgressBars(readSections, map);
        addOsasQuestionnaireResults(readSections, map);

        return map;
    }
}
